import { createContext, useContext } from "react";
import type { ResultExit } from "./resultExit.js";

const ResultExitContext = createContext<ResultExit | undefined>(undefined);

export const ResultExitProvider = ResultExitContext.Provider;

export function useResultExit(): ResultExit | undefined {
  return useContext(ResultExitContext);
}
